import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "maintenance-hint-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FullScreenLoading = _resolveComponent("FullScreenLoading")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "app" }, {
    default: _withCtx(() => [
      (_ctx.$tStore.isMaintenance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", null, "メンテナンス中", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, {
        style: _normalizeStyle(_ctx.backgroundThemeStyle)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          _createVNode(_component_FullScreenLoading, {
            isLoading: _ctx.$tStore.isLoading,
            opacity: _ctx.$tStore.opacity
          }, null, 8, ["isLoading", "opacity"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}